import { apiClient } from '../../apiHelper';
import { useFetch, useCreate, useGenericMutation } from '../react-query';


export function useGetFindingsByStudyInstanceUid(studyInstanceUid: string) {
  const getFindingsByStudyInstanceUidFn = async () => {
    const response = await apiClient.get(`/findings/study/${studyInstanceUid}`);
    return response?.data;
  };

  return useFetch(getFindingsByStudyInstanceUidFn, [`findings/${studyInstanceUid}`]);
}
